/** Endpoints #11-#15 — groups list, create, rename/reschedule, membership, delete. */

import type {
  CreateGroupBody,
  GroupResponse,
  GroupsListResponse,
  SetGroupMembersBody,
  UpdateGroupBody,
} from '@lw/shared';
import { apiJson, apiVoid } from './client';

/** #11 `GET /api/groups` */
export function listGroups(signal?: AbortSignal): Promise<GroupsListResponse> {
  return apiJson<GroupsListResponse>('/groups', { signal });
}

/** #12 `POST /api/groups` — `409 conflict` when the name is taken. */
export function createGroup(body: CreateGroupBody): Promise<GroupResponse> {
  return apiJson<GroupResponse>('/groups', { method: 'POST', body });
}

/** #13 `PATCH /api/groups/:id` */
export function updateGroup(id: number, body: UpdateGroupBody): Promise<GroupResponse> {
  return apiJson<GroupResponse>(`/groups/${id}`, { method: 'PATCH', body });
}

/** #14 `PUT /api/groups/:id/members` */
export function setGroupMembers(id: number, body: SetGroupMembersBody): Promise<GroupResponse> {
  return apiJson<GroupResponse>(`/groups/${id}/members`, { method: 'PUT', body });
}

/** #15 `DELETE /api/groups/:id` — members are untouched. */
export function deleteGroup(id: number): Promise<void> {
  return apiVoid(`/groups/${id}`, { method: 'DELETE' });
}
